import {
  AgeingBucketsReduxState,
  DashboardOperationsSummaryReduxState,
  DashboardPortfolioAnalyticsSummaryReduxState,
  DashboardReducerDispatch,
  DashboardReduxTypes,
  DisbursementByFYGraphReduxState,
  ProductMixReduxState,
  ProgramPerformanceReduxState,
  RenewalAndExpiryReduxState,
  TxnsByUserReduxState
} from "./types";

const DASHBOARD_OPERATIONS_SUMMARY_INIT_STATE: DashboardOperationsSummaryReduxState = {
  data: null,
  loading: false,
  error: null
};

const RENEWAL_AND_EXPIRY_INIT_STATE: RenewalAndExpiryReduxState = {
  data: null,
  loading: false,
  error: null
};

const TXNS_BY_USER_INIT_STATE: TxnsByUserReduxState = {
  data: null,
  loading: false,
  error: null
};

const PROGRAM_PERFORMANCE_INIT_STATE: ProgramPerformanceReduxState = {
  data: null,
  loading: false,
  error: null
};

const PRODUCT_MIX_INIT_STATE: ProductMixReduxState = {
  data: null,
  loading: false,
  error: null
};

const DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY_INIT_STATE: DashboardPortfolioAnalyticsSummaryReduxState = {
  data: null,
  loading: false,
  error: null
};

const AGEING_BUCKETS_INIT_STATE: AgeingBucketsReduxState = {
  data: null,
  loading: false,
  error: null
};

const DISBURSEMENT_BY_FY_GRAPH_INIT_STATE: DisbursementByFYGraphReduxState = {
  data: null,
  loading: false,
  error: null
};

const DashboardOperationsSummaryReducer = (
  state: DashboardOperationsSummaryReduxState = DASHBOARD_OPERATIONS_SUMMARY_INIT_STATE,
  action: DashboardReducerDispatch
) => {
  switch (action.type) {
    case DashboardReduxTypes.FETCH_DASHBOARD_OPERATIONS_SUMMARY:
      return {
        ...state,
        loading: true,
        error: null
      };
    case DashboardReduxTypes.FETCH_DASHBOARD_OPERATIONS_SUMMARY_SUCCESS:
      return {
        ...state,
        data: action.payload.data as DashboardOperationsSummaryReduxState["data"],
        loading: false
      };
    case DashboardReduxTypes.FETCH_DASHBOARD_OPERATIONS_SUMMARY_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    case DashboardReduxTypes.RESET:
      return {
        ...DASHBOARD_OPERATIONS_SUMMARY_INIT_STATE
      };
    default:
      return { ...state };
  }
};

const RenewalAndExpiryReducer = (
  state: RenewalAndExpiryReduxState = RENEWAL_AND_EXPIRY_INIT_STATE,
  action: DashboardReducerDispatch
) => {
  switch (action.type) {
    case DashboardReduxTypes.FETCH_RENEWAL_AND_EXPIRY:
      return {
        ...state,
        loading: true,
        error: null
      };
    case DashboardReduxTypes.FETCH_RENEWAL_AND_EXPIRY_SUCCESS:
      return {
        ...state,
        data: action.payload.data as RenewalAndExpiryReduxState["data"],
        loading: false
      };
    case DashboardReduxTypes.FETCH_RENEWAL_AND_EXPIRY_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    case DashboardReduxTypes.RESET:
      return {
        ...RENEWAL_AND_EXPIRY_INIT_STATE
      };
    default:
      return { ...state };
  }
};

const TxnsByUserReducer = (state: TxnsByUserReduxState = TXNS_BY_USER_INIT_STATE, action: DashboardReducerDispatch) => {
  switch (action.type) {
    case DashboardReduxTypes.FETCH_TXNS_BY_USER:
      return {
        ...state,
        loading: true,
        error: null
      };
    case DashboardReduxTypes.FETCH_TXNS_BY_USER_SUCCESS:
      return {
        ...state,
        data: action.payload.data as TxnsByUserReduxState["data"],
        loading: false
      };
    case DashboardReduxTypes.FETCH_TXNS_BY_USER_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    case DashboardReduxTypes.RESET:
      return {
        ...TXNS_BY_USER_INIT_STATE
      };
    default:
      return { ...state };
  }
};

const ProgramPerformanceReducer = (
  state: ProgramPerformanceReduxState = PROGRAM_PERFORMANCE_INIT_STATE,
  action: DashboardReducerDispatch
) => {
  switch (action.type) {
    case DashboardReduxTypes.FETCH_PROGRAM_PERFORMANCE:
      return {
        ...state,
        loading: true,
        error: null
      };
    case DashboardReduxTypes.FETCH_PROGRAM_PERFORMANCE_SUCCESS:
      return {
        ...state,
        data: action.payload.data as ProgramPerformanceReduxState["data"],
        loading: false
      };
    case DashboardReduxTypes.FETCH_PROGRAM_PERFORMANCE_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    case DashboardReduxTypes.RESET:
      return {
        ...PROGRAM_PERFORMANCE_INIT_STATE
      };
    default:
      return { ...state };
  }
};

const ProductMixReducer = (state: ProductMixReduxState = PRODUCT_MIX_INIT_STATE, action: DashboardReducerDispatch) => {
  switch (action.type) {
    case DashboardReduxTypes.FETCH_PRODUCT_MIX:
      return {
        ...state,
        loading: true,
        error: null
      };
    case DashboardReduxTypes.FETCH_PRODUCT_MIX_SUCCESS:
      return {
        ...state,
        data: action.payload.data as ProductMixReduxState["data"],
        loading: false
      };
    case DashboardReduxTypes.FETCH_PRODUCT_MIX_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    case DashboardReduxTypes.RESET:
      return {
        ...PRODUCT_MIX_INIT_STATE
      };
    default:
      return { ...state };
  }
};

const DashboardPortfolioAnalyticsSummaryReducer = (
  state: DashboardPortfolioAnalyticsSummaryReduxState = DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY_INIT_STATE,
  action: DashboardReducerDispatch
) => {
  switch (action.type) {
    case DashboardReduxTypes.FETCH_DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY:
      return {
        ...state,
        loading: true,
        error: null
      };
    case DashboardReduxTypes.FETCH_DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY_SUCCESS:
      return {
        ...state,
        data: action.payload.data as DashboardPortfolioAnalyticsSummaryReduxState["data"],
        loading: false
      };
    case DashboardReduxTypes.FETCH_DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    case DashboardReduxTypes.RESET:
      return {
        ...DASHBOARD_PORTFOLIO_ANALYTICS_SUMMARY_INIT_STATE
      };
    default:
      return { ...state };
  }
};

const AgeingBucketsReducer = (
  state: AgeingBucketsReduxState = AGEING_BUCKETS_INIT_STATE,
  action: DashboardReducerDispatch
) => {
  switch (action.type) {
    case DashboardReduxTypes.FETCH_AGEING_BUCKETS:
      return {
        ...state,
        loading: true,
        error: null
      };
    case DashboardReduxTypes.FETCH_AGEING_BUCKETS_SUCCESS:
      return {
        ...state,
        data: action.payload.data as AgeingBucketsReduxState["data"],
        loading: false
      };
    case DashboardReduxTypes.FETCH_AGEING_BUCKETS_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    case DashboardReduxTypes.RESET:
      return {
        ...AGEING_BUCKETS_INIT_STATE
      };
    default:
      return { ...state };
  }
};

const DisbursementByFYGraphReducer = (
  state: DisbursementByFYGraphReduxState = DISBURSEMENT_BY_FY_GRAPH_INIT_STATE,
  action: DashboardReducerDispatch
) => {
  switch (action.type) {
    case DashboardReduxTypes.FETCH_DISBURSEMENT_BY_FY_GRAPH:
      return {
        ...state,
        loading: true,
        error: null
      };
    case DashboardReduxTypes.FETCH_DISBURSEMENT_BY_FY_GRAPH_SUCCESS:
      return {
        ...state,
        data: action.payload.data as DisbursementByFYGraphReduxState["data"],
        loading: false
      };
    case DashboardReduxTypes.FETCH_DISBURSEMENT_BY_FY_GRAPH_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    case DashboardReduxTypes.RESET:
      return {
        ...DISBURSEMENT_BY_FY_GRAPH_INIT_STATE
      };
    default:
      return { ...state };
  }
};

export {
  DashboardOperationsSummaryReducer,
  RenewalAndExpiryReducer,
  TxnsByUserReducer,
  ProgramPerformanceReducer,
  ProductMixReducer,
  DashboardPortfolioAnalyticsSummaryReducer,
  AgeingBucketsReducer,
  DisbursementByFYGraphReducer
};
